import { useLoaderData, useRevalidator } from 'react-router-dom';
import { stopPlayer } from '../../API/v1/StopPlayer';
import {useAuthContext} from '../../contexts/authContext';
import { Button, Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, Chip } from '@mui/material';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import TvOffIcon from '@mui/icons-material/TvOff';

function PlayerTable() {

  const loader = useLoaderData();
  const { socket } = useAuthContext();
  const revalidator = useRevalidator();
  socket.off('reloadPlayers');
  socket.on('reloadPlayers', () => {
    revalidator.revalidate();
  });

  async function sendStopPlayer(key) {
    await stopPlayer(key);
  }

  var rows = null;
  if (loader && loader.length > 0) {
    rows = loader.map((channel) => (
      <TableRow key={channel.redisKey}>
        <TableCell align="center">
          <Chip label={channel.channelName} variant="outlined" size="small" sx={{ fontWeight: 600 }} />
        </TableCell>
        <TableCell align="center">
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<StopCircleIcon />}
            onClick={() => sendStopPlayer(channel.redisKey)}
          >
            Parar
          </Button>
        </TableCell>
      </TableRow>
    ));
  } else {
    rows = (
      <TableRow>
        <TableCell colSpan={2} align="center" sx={{ py: 5 }}>
          <TvOffIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
          <Typography color="text.secondary" variant="body2">
            No hay reproducciones activas
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ px: 3, pt: 3, pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Reproducciones activas</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Sesiones de reproducción en curso
        </Typography>
      </Box>
      <TableContainer>
        <Table aria-label="channels table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Canal</TableCell>
              <TableCell align="center">Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default PlayerTable;
